<div class="container">

    <mat-tab-group class="tab-content" [selectedIndex]="currentTab" (selectedTabChange)="onTabChange($event)">

        <mat-tab label="Favorite">
            <app-admin-favorites
                *ngIf="currentTab === enums.AdminProjectsTabEnum.favorite"
                [data]="data"
                [currentSortOption]="currentSortOption"
                [loading]="loading | async"
                [noContentText]="noContentText"
                (dataSourceChangeInfinityScroll)="onDataSourceChangeInfinityScroll($event)"
                (sortOptions)="onSortOptions($event)"
                (goTo)="onGoTo($event)"
                (createFavorite)="onCreateFavorite($event)"
                (deleteFavorite)="onDeleteFavorite($event)"
                (copyEmitter)="onCopyProject($event)"
            ></app-admin-favorites>
        </mat-tab>

        <mat-tab label="Open">
            <app-admin-active-projects
                *ngIf="currentTab === enums.AdminProjectsTabEnum.active"
                [data]="data"
                [currentSortOption]="currentSortOption"
                [loading]="loading | async"
                [noContentText]="noContentText"
                (dataSourceChangeInfinityScroll)="onDataSourceChangeInfinityScroll($event)"
                (sortOptions)="onSortOptions($event)"
                (goTo)="onGoTo($event)"
                (createFavorite)="onCreateFavorite($event)"
                (deleteFavorite)="onDeleteFavorite($event)"
                (copyEmitter)="onCopyProject($event)"
                ></app-admin-active-projects>
        </mat-tab>

        <mat-tab label="Locked">
            <app-admin-locked-projects
                *ngIf="currentTab === enums.AdminProjectsTabEnum.locked"
                [data]="data"
                [currentSortOption]="currentSortOption"
                [loading]="loading | async"
                [noContentText]="noContentText"
                (dataSourceChangeInfinityScroll)="onDataSourceChangeInfinityScroll($event)"
                (sortOptions)="onSortOptions($event)"
                (goTo)="onGoTo($event)"
                (createFavorite)="onCreateFavorite($event)"
                (deleteFavorite)="onDeleteFavorite($event)"
                (copyEmitter)="onCopyProject($event)"
                ></app-admin-locked-projects>
        </mat-tab>

    </mat-tab-group>
    <cx-floating-button [icon]="'add'" (isMenuActiveChange)="addRedirect()" [text]="'Add'"></cx-floating-button>

</div>

<app-footer-admin></app-footer-admin>
